var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 11.8571C13.875 11.8571 15.4286 10.3304 15.4286 8.42857C15.4286 6.55357 13.875 5 12 5C10.0982 5 8.57143 6.55357 8.57143 8.42857C8.57143 10.3304 10.0982 11.8571 12 11.8571ZM14.3839 12.7143H13.9286C13.3393 13.0089 12.6964 13.1429 12 13.1429C11.3036 13.1429 10.6339 13.0089 10.0446 12.7143H9.58929C7.60714 12.7143 6 14.3482 6 16.3304V17.4286C6 18.1518 6.5625 18.7143 7.28571 18.7143H16.7143C17.4107 18.7143 18 18.1518 18 17.4286V16.3304C18 14.3482 16.3661 12.7143 14.3839 12.7143Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.5c24664cb77391e95e2f27c2c52802e6.svg";
export { ForwardRef as ReactComponent };